export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#09090b" stroke="rgba(255,255,255,0.14)" />
    <path d="M38 17.5A15 15 0 1 0 38 46.5" fill="none" stroke="#E4A9B1" strokeWidth="6" strokeLinecap="round" />
    <path d="M31 24h17M31 32h12M31 40h17" stroke="#FED9DE" strokeWidth="5" strokeLinecap="round" />
  </svg>
);
